import React, {useEffect, useState} from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import {styles} from "./styles.jsx";
import Create from "@material-ui/icons/Create";
import general from "../../general";
import connection from "../../connection";
import UserSearch from "../UserSearch";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import SweetAlert from "../SweetAlertWrapper";
import Card from "../Card/Card";
import CardHeader from "../Card/CardHeader.jsx";
import Button from "../CustomButtons/Button.jsx";
import ReactTable from "react-table";
import Add from "@material-ui/icons/Add";
import {faTimes} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function EquipaFormacao(props) {
  const {classes, label, utilizador, acontecimento} = props;
  const [equipa, setEquipa] = useState(null);
  const [modal, setModal] = useState(null);

  useEffect(() => {
    connection.get("acontecimento/equipa", {acontecimento: acontecimento.id_acontecimento}).then(setEquipa);
  }, [acontecimento]);

  const editarEquipa = async () => {
    let funcoes = await connection.get("acontecimento/equipa/funcoes", {tipo_acontecimento: acontecimento.tipo_acontecimento});

    let dados = {
      acontecimento: acontecimento.id,
      equipa: equipa?.filter(e => e.tipo_utilizador !== "DIRETOR").map(e => ({funcao: e.tipo_utilizador, utilizador: e.utilizador})) || []
    };

    let Content = () => {
      const [numero_elementos, setNumeroElementos] = useState(dados.equipa.length);
      const [equipa, setEquipa] = useState([...dados.equipa]);

      useEffect(() => {
        dados.equipa = equipa;
      }, [equipa]);

      return <form autoComplete="off" className={classes.editForm}>
        {new Array(numero_elementos).fill(0).map((_, i) => <React.Fragment key={i}>
          <CardHeader className={"user_row"} color={"info"} key={equipa[i]?.utilizador?.NIN}>
            <Button
              size={"sm"}
              justIcon
              simple
              round
              onClick={() => {
                setNumeroElementos(numero_elementos - 1);
                setEquipa(equipa.filter((_, j) => j !== i));
              }}
              color="danger"
            >
              <FontAwesomeIcon icon={faTimes} color={"#bb0000"}/>
            </Button>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel className={classes.selectLabel}>
                Função
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu
                }}
                classes={{
                  select: classes.select
                }}
                value={equipa[i]?.funcao}
                onChange={(event) => {
                  if (!equipa[i])
                    equipa[i] = {};
                  equipa[i] = {...equipa[i]};
                  equipa[i].funcao = event.target.value;
                  setEquipa([...equipa]);
                }}>
                <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha a função</MenuItem>
                {funcoes.map((item) => {
                  return <MenuItem key={item.tipo_utilizador} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={item.tipo_utilizador}>{item.designacao}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <UserSearch
              labelText="Utilizador"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                type: "number",
                min: "0"
              }}
              defaultUser={equipa[i]?.utilizador}
              onFoundUser={(user) => {
                if (!equipa[i])
                  equipa[i] = {};
                equipa[i] = {...equipa[i]};
                equipa[i].utilizador = user;
                setEquipa([...equipa]);
              }}
            />
          </CardHeader>
        </React.Fragment>)}
        <div style={{textAlign: "center"}}>
          <Button
            size={"sm"}
            onClick={() => {
              setNumeroElementos(numero_elementos + 1);
            }}
            color="info"
          >
            <Add/> Adicionar elemento
          </Button>
        </div>
      </form>
    };

    setModal(<SweetAlert
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>Gerir Equipa</span>
      </div>)}
      onConfirm={async () => {
        await connection.post("acontecimento/equipa/alterar?acontecimento=" + acontecimento.id_acontecimento, {
          equipa: dados.equipa.filter(e => e?.funcao).map(e => ({funcao: e.funcao, NIN: e.utilizador.NIN}))
        });
        setModal(null);
        connection.get("acontecimento/equipa", {acontecimento: acontecimento.id_acontecimento}).then(setEquipa);
        general.success("Equipa alterada.", "Sucesso");
      }}
      onCancel={() => setModal(null)}
      cancelBtnText="Cancelar"
      showCancel
      confirmBtnText="Guardar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }>
      <Content/>
    </SweetAlert>);
  };

  return <Card className={classes.cardEquipaFormacao}>
    {modal}
    <CardHeader color="primary">
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
        <h4 style={{flex: 1}}>Equipa de Formação</h4>
        {acontecimento.pode_gerir && ((acontecimento.estado.code < general.estadosAcontecimento.FINALIZADO || general.userHasType("admin", "secretario_regional")) && acontecimento.estado.code < general.estadosAcontecimento.RELATORIO_SUBMETIDO) && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={editarEquipa}>
          <Create/> Editar
        </Button>}
      </div>
    </CardHeader>
    {equipa && <ReactTable
      minRows={1}
      data={equipa}
      columns={[
        {
          accessor: "funcao"
        },
        {
          accessor: "utilizador.nome_curto"
        }
      ]}
      defaultPageSize={20}
      showPaginationBottom={false}
      className="-striped -highlight"
    />}
  </Card>
}

export default withStyles(styles)(EquipaFormacao);
